import React from "react";
import {  useDispatch } from "react-redux";
import PageContent from "../PageContent";
import Icon from "../Icon";
import RoundIcon from "../RoundIcon";

import { next } from "../../logic/actions/navigation";
import "./style.css";

export default function PageIntroScreen() {
  const dispatch = useDispatch()

  function nextPage(){
    next()(dispatch)
  }

  return (
    <PageContent showVersion={true} progressBar={true} progressPercentage={0}>
      <h1>Open your bank account</h1>
      <p className="center">Verify your identity in just a few minutes.</p>

      <div>
        <div className="panel-intro">
          <RoundIcon color="grey">
            <Icon name="Phone" large="true" />
          </RoundIcon>
          <p className="center">
            Validate <br /> your phone <br /> number.
          </p>
        </div>
        <div className="panel-intro ">
          <RoundIcon color="grey">
            <Icon name="Selfie" large="true" />
          </RoundIcon>
          <p className="center">
            Take a selfie <br /> showing <br /> your face.
          </p>
        </div>
        <div className="panel-intro ">
          <RoundIcon color="grey">
            <Icon name="ID" large="true" />
          </RoundIcon>
          <p className="center">
            Verify your <br /> document ID.
          </p>
        </div>
        <div className="panel-intro ">
          <RoundIcon color="grey">
            <Icon name="Face-scan" large="true" />
          </RoundIcon>
          <p className="center">
            Perform <br /> liveness check.
          </p>
        </div>
      </div>

      <button className="btn blue" onClick={nextPage}>
        Get Started
      </button>
    </PageContent>
  );
}
